import React from "react";

export const Immigration = React.createContext();
export const Taxes = React.createContext();
export const Crime = React.createContext();
export const Injury = React.createContext();
export const Family = React.createContext();

export const getAdvancedFiltersContext = (formName) => {
    switch (formName) {
        case "Immigration":
            return Immigration;
        case "Taxes":
            return Taxes;
        case "Crime":
            return Crime;
        case "Injury":
            return Injury;
        case "Family":
            return Family;

        default:
            return React.createContext();
    }
};
